export const Stories = [
  {
    subtitle:"Nepal",
    title:"The Art of Letting Go",
    description:"Hiking with headlamps, masala tea sunrise, and surrender at its finest in Nepal",
    backgroundImage:"images/nepal-hero-main.jpg",
    link:'/nepal'
  },
  {
    subtitle:"Cuba",
    title:"The Gift of Gratitude",
    description:"Hand-rolled cigars, the rumble of a 1950's BelAir, and finding presence in Cuba",
    backgroundImage:"images/cuba-hero.jpg",
    link:'/cuba'
  },
  {
    subtitle:"Ecuador & Beyond",
    title:"Introduction",
    description:"An Andean adventure, bridging the gap, and finding joy in the jet lag",
    backgroundImage:"images/intro-hero.jpg",
    link:'/intro'
  }
]



// WEBPACK FOOTER //
// ./src/utils/stories.js